// extracted by mini-css-extract-plugin
module.exports = {"outer-wrapper":"Layout_outer-wrapper__CSqPN","inner-wrapper":"Layout_inner-wrapper__12nvB"};